import React, { Component } from "react";
import Modal from "../common/Modal";
import { IMAGE_URI } from "../../utils/config";
import isEmpty from "../../validation/is-empty";

export class ViewUser extends Component {
  handleCancelViewUser = () => {
    this.props.handleCancelViewUser();
  };
  render() {
    const { user } = this.props;
    return (
      <Modal
        id="viewUser"
        key="viewUser"
        open={true}
        size={"medium"}
        header="View User"
        onClose={this.handleCancelViewUser}
      >
        <div className="row">
          <div className="col-md-12">
            <div
              className="profile-image"
              style={{ textAlign: "center", marginBottom: "30px" }}
            >
              {isEmpty(user.attachment) ? (
                <img
                  className="pro-img"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%"
                  }}
                  src={require("../../assets/img/profile.png")}
                  alt={user.name}
                />
              ) : (
                <img
                  className="pro-img"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%"
                  }}
                  src={`${IMAGE_URI}/${user.attachment.dir}/${user.attachment.filename}`}
                  alt={user.name}
                />
              )}
            </div>
          </div>
          <div
            className="col-md-12"
            style={{ textAlign: "center", marginBottom: "30px" }}
          >
            <div className="col-md-6">
              <label style={{ float: "right" }}>Name:</label>
            </div>
            <div className="col-md-6">
              <span style={{ float: "left" }}>{user.name}</span>
            </div>
          </div>
          <div
            className="col-md-12"
            style={{ textAlign: "center", marginBottom: "30px" }}
          >
            <div className="col-md-6">
              <label style={{ float: "right" }}>Email:</label>
            </div>
            <div className="col-md-3">
              <span style={{ float: "left" }}>{user.email}</span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ViewUser;



// WEBPACK FOOTER //
// ./src/components/Admin/ViewAdmin.js